import React from "react";
import Center from "../../../../widget/common/ui/Center";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import {
  LoginEmailTextField,
  LoginPasswordTextField,
  LoginPhoneTextField,
} from "./LoginTextFields";
import {
  ButtonSingle,
  ButtonDouble,
} from "../../../../widget/common/form/Button";
import { TextInline } from "../../../../widget/common/ui/Text";
import Div from "../../../../widget/common/ui/Div";
import { appRoutes } from "../../../../routes/routes";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import { LoginContextImport } from "../../../../provider/onboarding/login/LoginContextProvider";
import { Col } from "react-bootstrap";
import { GoogleSignIn } from "../../../../widget/common/ui/SocialSignIn";
import { navigate } from "../../../../service/navigation/Navigation";

const LoginBody = () => {
  const type: number = ResponsiveDeviceType();
  const {
    tabName,
    handleClickLogin,
    handleClickContinueGuest,
    socialGoogleSuccess,
    handleChangeTab,
  } = LoginContextImport();

  return (
    <form id="form-login" autoComplete="off">
      <Center className="py-4">
        <Col xs={12} md={8}>
          <Center>
            <LogoRound
              url={AppConfigService.get("company_logo")}
              name={AppConfigService.get("company_name")}
              className="login-logo"
              size={type === 1 ? 150 : 170}
            />
          </Center>
          <SpacingHeight value={type === 1 ? 40 : 55} />
          <LoginTab onClick={handleChangeTab} tabName={tabName} />
          <SpacingHeight value={type === 1 ? 25 : 35} />
          {tabName === "email" ? (
            <LoginEmailTextField />
          ) : (
            <LoginPhoneTextField />
          )}

          <LoginPasswordTextField />
          <SpacingHeight value={type === 1 ? 30 : 40} />
          <Center>
            <ButtonSingle
              handleClick={handleClickLogin}
              width={type === 1 ? 180 : type === 2 ? 350 : 308}
            >
              {AppTranslation.text("sign_in")}
            </ButtonSingle>
          </Center>
          <Center className="color-theme-sublabel font-size-12_14">
            <div
              role="button"
              className="py-3 px-4"
              onClick={() => navigate(appRoutes.routeNameRecoverPassword)}
            >
              {AppTranslation.text("forgot_your_password")}
            </div>
          </Center>

          <SpacingHeight value={type === 2 ? 30 : 20} />
          <Center>
            {/* <IconCircleFilledIcon
              name="facebook_ic"
              className="mx-1"
              handleClick={() => {}}
            /> */}

            <GoogleSignIn
              handleSuccess={socialGoogleSuccess}
              handleFailure={() => {}}
            >
              <IconCircleFilledIcon name="google_ic" className="mx-1" />
            </GoogleSignIn>
          </Center>
          <SpacingHeight value={type === 1 ? 16 : type === 2 ? 15 : 18} />
          <Div fontSize="16_17">
            <Center>
              <TextInline fontName="bold">
                {AppTranslation.text("new_user")}?
              </TextInline>
              <div
                role="button"
                onClick={() => navigate(appRoutes.routeNameSignupThirdParty)}
              >
                <TextInline
                  textColor="theme-sublabel"
                  fontName="bold"
                  className="ms-1"
                >
                  {AppTranslation.text("sign_up")}
                </TextInline>
              </div>
            </Center>
          </Div>
          <Div className="pt-2 d-center" fontSize="12_14">
            <div role="button" onClick={handleClickContinueGuest}>
              <Center>
                <TextInline fontName="bold" className="me-1">
                  {AppTranslation.text("continue_as_a")}
                </TextInline>
                <TextInline
                  textColor="theme-sublabel"
                  fontName="bold"
                  className="ms-1"
                >
                  {AppTranslation.text("guest")}
                </TextInline>
              </Center>
            </div>
          </Div>
        </Col>
      </Center>
    </form>
  );
};

export default LoginBody;

const LoginTab = (props: {
  onClick: (name: "email" | "phone") => void;
  tabName: "email" | "phone";
}) => {
  return (
    <ButtonDouble
      isTab={true}
      tabId={props.tabName === "email" ? "1" : "2"}
      title1="email"
      title2="phone"
      handleClick1={() => props.onClick("email")}
      handleClick2={() => props.onClick("phone")}
    />
  );
};
